export const MAX_CHAT_UPLOAD_BYTES = 10034800; // 10mb
